function toValidDate(value) {
  if (!value) {
    return null;
  }

  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

function formatDisplayDate(value, fallback = 'Unknown') {
  const date = toValidDate(value);
  if (!date) {
    return fallback;
  }

  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(date);
}

function formatDisplayDateTime(value, fallback = 'Unknown') {
  const date = toValidDate(value);
  if (!date) {
    return fallback;
  }

  const datePart = formatDisplayDate(date, fallback);
  const timePart = new Intl.DateTimeFormat('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).format(date);

  return `${datePart}, ${timePart}`;
}

export {
  formatDisplayDate,
  formatDisplayDateTime,
};
